const sanitizeSegment = (segment: string): string => segment.trim().replace(/^\/+|\/+$/g, '')

export const buildApiPath = (...segments: Array<string | number | null | undefined>): string => {
  const normalized = segments
    .map((segment) => (segment === null || segment === undefined ? '' : String(segment)))
    .map(sanitizeSegment)
    .filter(Boolean);

  return `/${normalized.join('/')}`;
}

export const buildApiV1Path = (...segments: Array<string | number | null | undefined>): string => {
  return buildApiPath('api', 'v1', ...segments);
}

export const buildAdminConfigPath = (...segments: Array<string | number | null | undefined>): string => {
  return buildApiV1Path('admin', 'config', ...segments);
}
